import { Component } from '@angular/core';

@Component({
	selector: 'opus-layout',
	template: `<ng-content></ng-content>`,
})
export class LayoutComponent { }
